<template>
  <b-modal centered hide-header-close no-close-on-backdrop no-close-on-esc scrollable size="lg"
    title="Há um termo pendente, por favor leia-o por completo" v-model="existetermoAceitacao">
    <div v-if="existetermoAceitacao" v-html="termoAceitacao.TEXTO"></div>
    <template #modal-footer>
      <b-button @click="baixarTermo()">
        <font-awesome-icon icon="file-pdf" class="mr-2" />Download
      </b-button>
      <b-button variant="success" @click="aceitarTermo()">
        <font-awesome-icon icon="check" class="mr-2" />Aceitar termo
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { store } from "@/store";
import termoService from '@/services/termoService';
import { UtilsTS } from '@/utilsts';

export default {
  name: "TermoAceitacaoModalComponent",
  mixins: [UtilsTS],
  data() {
    return {
      showMobileUGSelector: false,
    };
  },
  computed: {
    termoAceitacao() {
      return store.termoPendente;
    },
    existetermoAceitacao() {
      return store.termoPendente !== null;
    },
  },
  methods: {
    async baixarTermo() {
      const response = await termoService.baixarTermo(this.termoAceitacao.ID_TERMO);
      if (response && response.status == 200)
        this.download("termo-portal-do-tce.pdf", response.data);
      else {
        this.$toast.error('Erro ao baixar o termo solicitado. Por favor recarregue a página e tente novamente.');
      }
    },
    async aceitarTermo() {
      const response = await termoService.aceitarTermo(this.termoAceitacao.ID_TERMO);
      if (response && response.status == 200) {
        this.$toast.success('Termo aceito');
        store.termoPendente = null;
      } else {
        this.$toast.error('Erro ao aceitar o termo. Por favor recarregue a página e tente novamente.');
      }
    },
  },
};
</script>

<style scoped>
div[id$='BV_modal_outer_'] {
  z-index: 9910 !important;
}
</style>